import { render, staticRenderFns } from "./global-footer.component.vue?vue&type=template&id=204ad853&"
import script from "./global-footer.component.vue?vue&type=script&lang=ts&"
export * from "./global-footer.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports